import { env } from '@fiverr-private/futile';
import { createBrowserHistory } from 'history';

const history = env.browser ? createBrowserHistory() : {
    location: {
        pathname: '',
        search: ''
    }
};

export default history;
